module.exports = __webpack_public_path__ + "static/media/instructions-center.0020f906.png";